<template>
  <div class="project-one-model-selector grid-container" qaid="project-one-model-selector">
    <project-one-bike-selection-card-list :base-properties="baseProperties" :bikes="bikes" />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import ProjectOneBikeSelectionCardList from '@/projectOne/components/bikeSelectionCards/ProjectOneBikeSelectionCardList';

export default {
  components: {ProjectOneBikeSelectionCardList},

  computed: {
    bikes() {
      return this.bikePackage?.packages;
    },

    ...mapState('projectOne', ['bikePackage']),
  },
};
</script>

<style lang="scss" scoped>
.project-one-model-selector {
  margin-top: 3rem;

  @screen lg {
    margin-top: 6rem;
  }
}
</style>
